import { render, staticRenderFns } from "./WithInYear.vue?vue&type=template&id=4546234f&scoped=true&lang=pug&"
import script from "./WithInYear.vue?vue&type=script&lang=js&"
export * from "./WithInYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4546234f",
  null
  
)

export default component.exports